import React, { useState, useEffect, useRef } from "react";
import "../../../resources/CommonCompoenent.scss";

export default function Dropdown(props) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownCmpRef = useRef(null);
  const { height, width, ...headerStyle } = props.style || {};


  useEffect(() => {
    let handler = (e) => {
      if (isOpen) {
        if (!dropdownCmpRef.current.contains(e.target)) {
          setIsOpen(false);
        }
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  const onSelectOption = (opt) => {
    setIsOpen(false);
    props.onChange(opt);
  };

  return (
    <div className="dropdown_container_outer" style={props.style?{width:props.style.width, height:props.style.height}:{}}>
     {props.label && <p className="dropdown_label">{props.label}</p>}
      <div className='dropdown_container' >
      <div ref={dropdownCmpRef} className={`dropdown_inner_container${isOpen ? " open" : ""} ${props.disabled ? "disabled" : ""}`} style={headerStyle}>
        <div className={`dropdown_header ${props.disabled ? "disabled" : ""}`} onClick={() =>props.disabled ? null : !isOpen && setIsOpen(!isOpen)}>
        <div className="value_container">
              <span
                style={{
                  color: isOpen ? "#818181" : "",
                  textTransform: "capitalize",
                }}
              >
                {props.renderValue
                  ? props.renderValue(props.value, props.options)
                  : props.value
                    ? `${props.value}`
                    : props.placeholder || "Select Value"}
              </span>
            </div>

          <svg className={`arrow_icon ${isOpen ? "open" : ""}`} xmlns='http://www.w3.org/2000/svg' width='12' height='6' viewBox='0 0 12 6' fill='none'>
            <path d='M0 0L6 6L12 0H0Z' fill='#303030' />
          </svg>
        </div>
        {isOpen && (
          <div className='options_container'>
            {props.options !== undefined && props.options.length > 0
              ? props.options.map((opt) => {
                  return (
                    <div className='option_item'>
                      <p onClick={() => onSelectOption(opt)}>{opt.text}</p>
                    </div>
                  );
                })
              : null}
          </div>
        )}
      </div>
    </div>
    </div>
    
  );
}
